<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Laboratory Check-in</h5>



    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #396f9b; color: white;">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th>Delivered Instrument Score</th>
            <th>Delivered Instrument Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DetailDownload">
            <td>{{DetailDownload.indexOf(item)+1}}</td>
            <td>{{item['fullname']}}</td>
            <td>{{item['devicePoint']}}</td>
            <td>{{item['deviceCount']}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />

    <ul>
      <li>Click the relevant field before scanning.</li>
      <li>Press Enter to validate the scanned code.</li>
      <li>Press Esc to clear the form.</li>

    </ul>

    <br />
    <br />

    <form>
      <button type="button" (click)="openModal_ExpertCalibration(templateExpertCalibration,-1)" class="btn btn-danger"
                style="margin-right: 5px;"> Search Calibration Technicians <i class="fa fa-user-circle-o"></i>
      </button>
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Name </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.name}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Last Name </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_ExpertCalibration.familly}}" />
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Click the field below before scanning the QR code. <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputDownload type="text" (keyup.enter)="QRCodeInputDownload_Enter()"
            (keyup.esc)="QRCodeInputDownload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="Click here...">
          <p [hidden]="!Procssing"> Please wait... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDownload()" type="button"
        [disabled]="Info_Download_List.length==0 || Data_Seleted_ExpertCalibration.id==0" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Check In Scanned Instruments </button>

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDownload_Enter()" type="button"
        class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Validate Instrument ID </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa  fa-recycle"></i> Start Over </button>

      <button routerLink="/LabDownloadUploadDevice" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>

    <br />
    <br />

    <div class="row" *ngIf="Info_Download_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Title Instrument</th>
                <th>Instrument Code</th>
                <th>Instrument Serial Number</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">System Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Download_List">
                <td>{{Info_Download_List.indexOf(item)+1}}</td>
                <td>{{item.userDsc}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button *ngIf="!FormSubmitted" (click)="Info_Download_Remove(Info_Download_List.indexOf(item))"
                    class="btn btn-danger"><i class="fa fa-remove"></i> Delete </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
</div>





<ng-template #templateExpertCalibration>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Calibration Technician List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ExpertCalibration
            |filter:Filter_Familly:'familly'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 20,
                        currentPage: ExpertCalibrationpage,
                        totalItems: (DataList_ExpertCalibration
                        |filter:Filter_Familly:'familly'
                        ).length
                      }
            ">
              <td>{{DataList_ExpertCalibration.indexOf(item)+1}}</td>
              <td>{{item.name}}</td>
              <td>{{item.familly}}</td>
              <td (click)="Set_Selected_ExpertCalibration_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_ExpertCalibration" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_ExpertCalibration" type="button" (click)="ReadData_ExpertCalibration()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ExpertCalibration.hide()">Close</button>
  </div>
</ng-template>
